const messages = {
    'b.login': '登录',
    'b.search': '搜索',
    'b.save': '保存',
    'b.submit': '提交',
    'b.cancel': '取消',
    'b.ok': '确定',
    'b.upload': '上传',
    'b.additem': '添加',
    'b.add': '添加',
    'b.edit': '编辑',
    'b.delete': '删除',
    'b.yes': '是',
    'b.no': '否',
    'b.export': '导出',
    'b.import': '导入',
    'b.batchimport': '批量导入',
    'b.account':'账户',
    'b.payment':'支付',
    'b.print':'打印',
    'b.reprint':'重新打印',
    'b.printselected':'打印选定',
    'b.sendtopo':'发送到 DPPO',
    'b.uploadsfbilling':'上传对账单',
    'b.savetolibrary':'保存到库',
    'b.downloadtemplate':'下载模板',
    'b.selectfile':'选择文件',
    'b.getdhlnilling':'下载对账单',
    'b.retry':"重试",
    'b.authorize': '授权',
    'b.queryestimatedcost': '查询预计费用',
    'b.addresses': '地址',
    'b.clearinfo': '清除信息',
    'b.saveaddress': '保存到地址簿',
    'b.submittoapproval': '提交审批',
    'b.approve': '批准',
    'b.reject': '拒绝',
    'b.return': '返回',
    'b.confirmbilling': '确认账单',
    'b.approvebilling': '批准账单',
    'b.copy': '复制为新',
    'b.change':"变更",
    'b.viewsignreceipt': '查看签收回执',
    'b.downloadbill': '下载账单',
    'b.downloadbillItems': '下载项目',
    'b.uploadbill': '上传项目',
    'b.test': '测试',
    'b.batchUpdateStatus': '批量更新状态',
    'b.disable': '禁用',
    'b.enable': '启用'
  };
  export default messages;
  